/**
 * Terminus NavProfileMenu Component v1.0.0
 */
import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faClose, faUserSecret } from '@fortawesome/pro-solid-svg-icons';

import { TooltipDirective } from '@terminus-ui/tooltip';
import { NavProfileData } from '../../models/nav.model';
import { UserInfo } from '../../models/user-info.model';
import { isNavLinkPipe } from '../../pipes/nav.pipes';
import { interceptClickEvent } from '../../util/click-interceptor';

@Component({
  selector: 'tux-nav-profile-menu',
  templateUrl: './nav-profile-menu.component.html',
  styleUrls: ['./nav-profile-menu.component.scss'],
  imports: [
    CommonModule,
    FontAwesomeModule,
    RouterModule,
    isNavLinkPipe,
    TooltipDirective,
  ],
})
export class NavProfileMenuComponent {
  closeIcon = faClose;
  userSecretIcon = faUserSecret;

  interceptClickEvent = interceptClickEvent;

  @Input() user: UserInfo;
  @Input() impersonatingUser = false;
  @Input() profileData: NavProfileData;
}
